import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import MaterialLink from '@material-ui/core/Link';
import MaterialBreadcrumbs from '@material-ui/core/Breadcrumbs';
import '../styles/Breadcrumbs.scss';

const Breadcrumbs = ({breadcrumbs}) => {
    useEffect(() => {
        let title = 'Tracker';
        if (breadcrumbs.length > 0) {
            title += ' -';
        }
        breadcrumbs.forEach(({name,}) => {
            title += ` ${name} ->`;
        });
        if (breadcrumbs.length > 0) {
            title = title.substring(0, title.length - 3);
        }
        document.title = title;
    }, [breadcrumbs]);

    // noinspection JSValidateTypes
    return (
        <MaterialBreadcrumbs className="breadcrumbs" aria-label="breadcrumb">
            <MaterialLink color="inherit" to="/" component={Link}>
                Главная
            </MaterialLink>
            {breadcrumbs.map((item, id) => (
                (item.to)
                    ? <MaterialLink key={id} color="inherit" to={item.to} component={Link}>{item.name}</MaterialLink>
                    : <Typography key={id}>{item.name}</Typography>
            ))}
        </MaterialBreadcrumbs>
    );
};

Breadcrumbs.propTypes = {
    breadcrumbs: PropTypes.array.isRequired,
};

export default Breadcrumbs;
